import script from "./AuPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./AuPagination.vue?vue&type=script&setup=true&lang=js"

import "./AuPagination.vue?vue&type=style&index=0&id=688b50e4&lang=scss"

const __exports__ = script;

export default __exports__